import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { FormControlLabel, FormGroup, Grid, Paper, Switch, TextField, Typography } from '@mui/material';

import AppDisplay from '../ui/AppDisplay';

import PageTitle from '../ui/PageTitle';
import SaveButton from '../ui/SaveButton';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import { disableAttributeCheck, getValueForRender } from '../../utils/InputUtils';

const abEnvironment = new AbEnvironment();
const TemplateAppEditQuery = graphql`
query TemplateAppEditQuery($appId: UUID!) {
  appTByAppId(appId: $appId) {
    appId
    accountId
    appStatus
    parentAppId
    oemAppId
    appName
    appSku
    appUrl
    signupUrl,
    appLogo
    description
    appType
    atId
    appSkuPrice
    appMarkupPercentage
    appMarkupAbsolute
    jitFloatDefault
    marqetaMid
    marqetaMname
    maxCharge
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    maxWidth: 980,
    marginTop: 16
  },
  paperInner: {
    padding: theme.spacing(2)
  }

});

class TemplateAppEdit extends Component {
  state = {
    showSpinner: false,
    saveStatus: null,
    saveMessage: null,
    saveSnackbarOpen: false,
    saveSnackbarDuration: null,
    marqetaMid: null,
    marqetaMname: null

  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  goBack() {
    this.props.history.goBack();
  }


  disableAppSave(appProps) {
    if (appProps === null)
      return true;

    let retval = disableAttributeCheck(this.state.marqetaMid, appProps.marqetaMid) &&
      disableAttributeCheck(this.state.marqetaMname, appProps.marqetaMname);

    return retval;
  }

  showSpinner() {
    return this.state.showSpinner;
  }


  render() {
    const { isAuthenticated, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent() || !isAuthenticatedAppBind()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedAppBind()) {
 
      const params = new URLSearchParams(this.props.location.search);
      let appId = params.get('appId');
 

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={TemplateAppEditQuery}
          variables={{ appId: appId }}
          render={({ error, props }) => {
            if (error) {
              logError(error.message);
              return (
                <ServerError />
              );
            } else if (props) {
              if (props.appTByAppId === null) {
                return (
                  <PageTitle title={"App not found"} showBackButton={true} name="Template app search" history={this.props.history}/>
                );
              }

              let theAppName = getValueForRender(this.state.appName, props.appTByAppId.appName, '');
              let theAppSku = getValueForRender(this.state.appSku, props.appTByAppId.appSku, '');
              let theDescription = getValueForRender(this.state.description, props.appTByAppId.description, '');


              return (
                <Grid container spacing={3} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    <PageTitle title="Manage template app" showBackButton={true} name="Template app search" noMargin={true} history={this.props.history}/>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        {/* Name, logo, active setting. */}
                        <Grid item xs={12} >
                          <Grid container spacing={0} direction="row" justifyContent='space-between' alignItems='flex-start'>
                            <Grid item xs={10}>
                              <AppDisplay appLogo={props.appTByAppId.appLogo}
                                appName={theAppName}
                                appSku={theAppSku}
                                description={theDescription} />
                            </Grid>
                            <Grid item>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={getValueForRender(this.state.appStatus, props.appTByAppId.appStatus, '') === 0}
                                    />
                                  }
                                  disabled={true}
                                  label="Active"
                                />
                              </FormGroup>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12}>

                            <Grid container spacing={2} direction="row" justifyContent="space-between">
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <Typography variant="h6">App description</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="app-name" label="App name"
                                        value={theAppName}
                                        inputProps={{ maxLength: 64 }}
                                        InputProps={{ disableUnderline: true }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="app-sku" label="Subscription plan"
                                        value={theAppSku}
                                        inputProps={{ maxLength: 32 }}
                                        InputProps={{ disableUnderline: true }}
                                      />
                                    </Grid>

                                    <Grid item xs={12}>
                                      <TextField
                                        id="description" label="Description"
                                        value={theDescription}
                                        multiline
                                        inputProps={{ maxLength: 2048 }}
                                        InputProps={{ disableUnderline: true }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container spacing={2}>

                                    <Grid item xs={12}>
                                      <Typography variant="h6">Marqeta information</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="marqeta-mid" label="Merchant ID"
                                        value={getValueForRender(this.state.marqetaMid,
                                          props.appTByAppId.marqetaMid, '')
                                        }
                                        onChange={(e) => this.setState({ marqetaMid: e.target.value })}
                                        inputProps={{ maxLength: 256 }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="marqeta-mname" label="Merchant Name"
                                        value={getValueForRender(this.state.marqetaMname,
                                          props.appTByAppId.marqetaMname, '')
                                        }
                                        onChange={(e) => this.setState({ marqetaMname: e.target.value })}
                                        inputProps={{ maxLength: 256 }}
                                      />
                                    </Grid>


                                  </Grid>
                                </Paper>
                              </Grid>
                              <Grid item >
                                <SaveButton
                                  snackbarOpen={this.state.saveSnackbarOpen}
                                  autoHideDuration={this.state.saveSnackbarDuration}
                                  status={this.state.saveStatus}
                                  message={this.state.saveMessage}
                                  disabled={this.disableAppSave(props.appTByAppId)}
                                  onSaveClick={() => { this.saveMarqetaInfo(appId, props) }}
                                  onSnackbarClose={() => { this._onSnackbarClose(); }}
                                />
                              </Grid>
                            </Grid>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              );
            }
            return <LoadingSpinner />
          }}
        />
      )
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  _onSnackbarClose() {
    this.setState({ saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }

  saveMarqetaInfo(appId, props) {
    // Call API to update customer app info
    this.setState({saveStatus: 'saving'});
    const { callPartnerApi } = this.props.auth;
    let mid = getValueForRender(this.state.marqetaMid, props.appTByAppId.marqetaMid, '');
    let mname = getValueForRender(this.state.marqetaMname, props.appTByAppId.marqetaMname, '');

    let payload = {
      operation: "updateAppTMarqetaInfo",
      params: {
        appId: appId,
        marqetaMid: mid,
        marqetaMname: mname      
      }
    };


    callPartnerApi('appbind/generic',
    'POST',
    payload)
    .then(resp => {
      window.location.reload();
    })
    .catch(resp => {
      window.location.reload();
    })
}

}

TemplateAppEdit.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(TemplateAppEdit);
